module.exports = __webpack_public_path__ + "static/media/mitutoyo.f53922f9.png";